// Definice rozhraní pro příchozí data ze socketu
interface SocketMessage {
  type: 'showAttachment' | string;
  id?: string | number;
  [key: string]: any;
}

export class MailFormSocket {
  private mailIdent: number;
  private socket: WebSocket | null = null;
  
  // Callback pro reakci v komponentě
  public onAttachmentRefresh?: () => void;

  constructor(mailIdent: number) {
    this.mailIdent = mailIdent;
    this.connect();
  }

  private connect(): void {
    // Elegantnější tvorba WS URL z aktuální lokace
    const url = new URL(`mailForm/${this.mailIdent}`, window.location.href);
    url.protocol = url.protocol.replace(/^http/, 'ws');

    this.socket = new WebSocket(url.href);

    // Použití arrow functions eliminuje potřebu .bind(this)
    this.socket.onopen = () => this.socketOpen();
    this.socket.onclose = (evt) => this.socketClose(evt);
    this.socket.onmessage = (evt) => this.socketMessage(evt);
    this.socket.onerror = (evt) => this.socketError(evt);
  }

  private socketOpen(): void {
    console.log(`WebSocket connected for: ${this.mailIdent}`);
  }

  private socketClose(evt: CloseEvent): void {
    console.log('WebSocket closed', evt.reason);
  }

  private socketError(event: Event): void {
    console.error("WebSocket error observed:", event);
  }

  private socketMessage(event: MessageEvent): void {
    try {
      const data: SocketMessage = JSON.parse(event.data);

      switch (data.type) {
        case "showAttachment":
          // Místo jQuery zavoláme callback, pokud je definován
          if (this.onAttachmentRefresh) {
            this.onAttachmentRefresh();
          }
          break;
        default:
          console.warn("Unsupported socket event:", data.type);
      }
    } catch (e) {
      console.error("Failed to parse socket message", e);
    }
  }

  public sendMessage(msg: object): void {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(msg));
    } else {
      console.error("Cannot send message - socket not ready", this.socket?.readyState);
    }
  }

  // Metoda pro korektní ukončení (např. v onUnmounted)
  public disconnect(): void {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}